import React, { useEffect, useState } from 'react';
import { ChevronUp } from 'lucide-react';

/**
 * A floating scroll-to-top arrow button that appears after scrolling down.
 * Place this component once in your layout or page.
 */
export const ScrollToTopArrow: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 200);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      aria-label="Scroll to top"
      onClick={handleClick}
      className={`fixed z-50 bottom-4 right-4 p-1.5 rounded-full bg-white/90 shadow-lg border border-gray-200 hover:bg-primary-500 hover:text-white transition-all duration-300 flex items-center justify-center backdrop-blur-md
        sm:bottom-8 sm:right-8 sm:p-3
        ${visible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}
      `}
      style={{ boxShadow: '0 4px 24px 0 rgba(0,0,0,0.08)' }}
    >
      <ChevronUp className="w-5 h-5 sm:w-7 sm:h-7" />
    </button>
  );
}; 